import { cn } from "src/lib/utils";

interface StatusBadgeProps {
    title: string;
    onClear: () => void;
    variant: "primary" | "secondary";
  }
  
export default function StatusBadge({ title, onClear, variant }: StatusBadgeProps) {
  
    const bgColor = variant === "primary" ? "bg-primary-100" : "bg-secondary-100";
    const textColor = variant === "primary" ? "text-primary-700" : "text-secondary-700";
    const hoverColor = variant === "primary" ? "hover:bg-primary-200" : "hover:bg-secondary-200";
  
    return (
      <span className={cn("px-3 py-1 rounded-full text-sm flex items-center gap-1", bgColor, textColor)}>
        {title}
        <button
          onClick={onClear}
          className={cn("ml-1 rounded-full p-0.5 h-4 w-4 flex items-center justify-center cursor-pointer", hoverColor)}
        >
          ×
        </button>
      </span>
    )
  }